export default __webpack_public_path__ + "static/media/arrow-right-purple.d6bf0c23.svg";